module.exports = __webpack_public_path__ + "img/world.e4491a9b.svg";